import React, { Fragment, useState } from "react";
import { Button, Card, CardBody, Form, FormGroup, Input, Label } from "reactstrap";
import FormUpload from "./FormUpload";
import { GetCookieToken } from "../Cookie/GetCookie";
import axios from "axios";
import LoadingData from "../TESTPage/LoadingData";
import { useEffect } from "react";

const API_URL = process.env.REACT_APP_API_CORS;

function AddTex(props) {
    const { refreshDataTable, setOpen } = props;
    const [loading, setLoading] = useState(false);
    const [fileUpload, setFileUpload] = useState(null);
    const [dataEdit, setDataEdit] = useState({ heading: '', content: '' });
    const [id, setID] = useState(0);

    const token = GetCookieToken("userToken");

    const handleFile = value => {
        setFileUpload(value);
    };

    useEffect(() => {
        const thisEffect = async () => {
            if (fileUpload?.length > 0 && id !== 0) {

                await fileUpload?.map(async (x) => {
                    let url = `${API_URL}/api/opdcNews/image/${id}`;
                    let formData = new FormData();
                    formData.append("file", x);
                    await fetch(url, {
                        method: "POST", headers: { Authorization: `Bearer ${token}`, },
                        body: formData,
                    })
                })
            }
            setLoading(false);
            setOpen(false);
            refreshDataTable();
        }
        id !== 0 && thisEffect();
    }, [id])

    const handleSubmit = async () => {
        setLoading(true);
        const url = `${API_URL}/api/opdcNews/save`;
        const config = { headers: { Authorization: `Bearer ${token}`, } };
        await axios.post(url, { ...dataEdit }, config).then(async response => {
            setID(() => response.data.insertedId)
        }).catch(error => console.error("Error:", error));
    }

    return (
        <Fragment>
            {loading ? (
                <div style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    minHeight: "400px",
                }}>
                    <LoadingData />
                </div>
            ) : (
                <Card>
                    <CardBody>
                        <Form
                            onSubmit={async e => {
                                e.preventDefault();
                                await handleSubmit();
                            }}
                        >
                            <FormGroup>
                                <Label>
                                    <b>หัวข้อข่าว</b>
                                </Label>
                                <Input
                                    defaultValue=''
                                    placeholder="หัวข้อข่าว"
                                    type="text"
                                    onChange={async (e) => { setDataEdit({ ...dataEdit, heading: e.target.value }) }}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label><b>เนื้อหาข่าว</b></Label>
                                <Input
                                    defaultValue=''
                                    placeholder="เนื้อหาข่าว"
                                    type="textarea"
                                    rows={20}
                                    onChange={async (e) => { setDataEdit({ ...dataEdit, content: e.target.value }) }}
                                />
                            </FormGroup>
                            <FormGroup>
                                <ul className="list-inine ps-0 mb-4" >
                                </ul>
                            </FormGroup>
                            <FormGroup>
                                <Label for="exampleFile">ไฟล์</Label>
                                <FormUpload onFileUpload={handleFile} />
                            </FormGroup>
                            <Button color="success" type="submit"><i className="fa-solid fa-floppy-disk-pen" aria-hidden="true"></i> บันทึก</Button>
                        </Form>
                    </CardBody>
                </Card>
            )}
        </Fragment >
    );
}

export default AddTex;
